import {
	Directive,
	HostListener,
	Input,
	ElementRef,
	HostBinding,
	Renderer2,
	AfterViewInit
} from "@angular/core";

@Directive({
    selector: "[dodo-raised-button]",
    standalone: false
})
export class DodoRaisedButtonDirective {
	private __element: HTMLElement;

	@HostBinding("style.height.px")
	@Input()
	height = 50;

	@Input() busy: boolean;

	constructor(er: ElementRef, __renderer: Renderer2) {
		const __element = er.nativeElement;
		__renderer.addClass(__element, "dodo-raised-button");
	}
}
